"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var _hubspotPluginCommon = require("hubspot-plugin-common");

var _ExperimentConstants = require("pricing-pages-unified-ui/constants/ExperimentConstants");

var _laboratoryLib = require("laboratory-lib");

var _laboratoryClient = require("laboratory-client");

var initialState = {
  showButton: false,
  showSimplifyTabs: false
};

var Wp006SimplifyTabs = function Wp006SimplifyTabs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.WP006_SIMPLIFY_TABS_REQUESTED:
      return {
        showButton: true,
        showSimplifyTabs: payload
      };

    case _ActionTypes.EXPERIMENT_TREATMENTS_RECEIVED:
      {
        if (_hubspotPluginCommon.isWordPress) {
          // !isWordPress to test outside of WP
          var treatment = (0, _laboratoryLib.getTreatment)(payload.treatments, _ExperimentConstants.WP006_TREATMENT_KEY);
          var isInVariant = (0, _laboratoryLib.getParameter)(treatment, _ExperimentConstants.WP006_PARAMETER).value === 'variant';
          (0, _laboratoryClient.logExposure)(treatment); // Auto is turned off

          return {
            showButton: isInVariant,
            showSimplifyTabs: isInVariant
          };
        } else return {
          showButton: false,
          showSimplifyTabs: false
        };
      }

    default:
      return state;
  }
};

var _default = Wp006SimplifyTabs;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Wp006SimplifyTabs.js
// module id = 522
// module chunks = 5 6